import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=73b75a0d&scoped=true&"
import script from "./partners.vue?vue&type=script&lang=js&"
export * from "./partners.vue?vue&type=script&lang=js&"
import style0 from "./partners.vue?vue&type=style&index=0&id=73b75a0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b75a0d",
  null
  
)

export default component.exports